module.exports = __webpack_public_path__ + "797cbb2d76a495d3757243f7f985332b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/account/defaultFreelance.png
// module id = 1719
// module chunks = 0